import { useFavorites, IconButton } from '@tunasong/ui-lib'
import { Header } from '../header.js'
import { Link as RouterLink } from 'react-router'
import { Home, Star, type IconName } from '@tunasong/icons'
import cn from 'classnames'
import type { HTMLAttributes } from 'react'
import starStyles from './favorite-star.module.css'
import styles from './page-header.module.css'

export interface PageHeaderProps extends HTMLAttributes<HTMLDivElement> {
  name?: string
  pageIconName?: IconName
  ref?: React.Ref<HTMLDivElement>
  showBackButton?: boolean
  /** Offer to favourite the page. Off for pages that cannot be favourited, such as Home. @default true */
  showFavorite?: boolean
}

export const PageHeader = (props: PageHeaderProps) => {
  const { name, ref, showBackButton = true, showFavorite = true, pageIconName, ...restProps } = props
  const { currentFavorite, addFavorite, removeFavorite } = useFavorites()

  return (
    <Header
      ref={ref}
      position="absolute"
      elevation={0}
      showBackButton={showBackButton}
      breadcrumbs={
        <nav aria-label="breadcrumb" className={styles.breadcrumb}>
          <RouterLink className={cn(styles.link, styles.homeLink)} to="/app" title="Home link" aria-label="Home link">
            <Home size={18} />
          </RouterLink>
          {name ? (
            <span className={styles.separator} aria-hidden="true">
              /
            </span>
          ) : null}
          {name ? (
            <RouterLink className={cn(styles.link, styles.nameLink)} to={`.`} title={name} aria-current="page">
              {name}
            </RouterLink>
          ) : null}
          {/* The star follows the crumbs, as on entity pages; the same glyph as the sidebar's Favorites */}
          {name && showFavorite ? (
            <IconButton
              color="inherit"
              className={starStyles.star}
              aria-pressed={Boolean(currentFavorite)}
              onClick={ev => {
                ev.preventDefault()
                ev.stopPropagation()
                if (currentFavorite) {
                  removeFavorite(currentFavorite)
                } else {
                  addFavorite({ name, iconName: pageIconName })
                }
              }}
              aria-label={currentFavorite ? 'Remove from favorites' : 'Add to favorites'}
            >
              <Star fill={currentFavorite ? 'currentColor' : 'none'} />
            </IconButton>
          ) : null}
        </nav>
      }
      {...restProps}
    />
  )
}
